export const checkCenterLat = (
  showHoleMarker,
  singleSiteLocationData,
  site,
  singleLocationLat,
  carData
) => {
  if ((showHoleMarker && singleSiteLocationData) || site) {
    return singleLocationLat[0]?.CenterPointLatitude;
  } else if (carData) {
    return carData[0]?.Car?.Latitude;
  } else if (singleSiteLocationData) {
    return singleLocationLat[0]?.CenterPointLatitude;
  } else if (singleLocationLat.length > 0) {
    return singleLocationLat[0]?.CenterPointLatitude;
  } else {
    return 20.766733;
  }
};